/* S1 Problem Story: fade-ins + first tap swaps the poster for a native
   <video controls autoplay> (SPA behaviour — the video element only exists
   after the click, so nothing preloads). */

class S1ProblemStory extends HTMLElement {
  connectedCallback() {
    if (!this._fadeIo) {
      this._fadeIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            this._fadeIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-ps-fade:not(.is-visible)').forEach((el) => this._fadeIo.observe(el));

    if (this._bound) return;
    this._bound = true;

    const play = this.querySelector('[data-ps-play]');
    const panel = this.querySelector('[data-ps-panel]');
    const tpl = this.querySelector('[data-ps-video-template]');
    if (!play || !panel || !tpl) return;
    play.addEventListener('click', () => {
      panel.appendChild(tpl.content.cloneNode(true));
      play.remove();
    });
  }

  disconnectedCallback() {
    if (this._fadeIo) this._fadeIo.disconnect();
  }
}

if (!customElements.get('s1-problem-story')) {
  customElements.define('s1-problem-story', S1ProblemStory);
}
